import { Col, Row, Image } from "antd";
import TestUI from "../TestUI";
import { PosturalExamination, PosturalTestDefinition } from "../interfaces";
import { TakenPhoto } from "../PosturalExamWrapper";
import "../../App.css";

const ComparePhotosComponent = ({
  page,
  images,
  testDefinitions,
  posturalExamination,
  setTestSelection,
  reverse = false,
}: {
  page: number;
  images: TakenPhoto[];
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
  reverse?: boolean;
}) => {
  const sortedTestDefinitions = testDefinitions ? [...testDefinitions].sort((td1, td2) => td1.id - td2.id) : [];

  const renderPhotoWithDefinitions = (photoIndex: number, topIndices: number[], bottomIndices: number[]) => {
    const photo = images[photoIndex];
    const topDefinitions = topIndices.map(index => sortedTestDefinitions[index]);
    const bottomDefinitions = bottomIndices.map(index => sortedTestDefinitions[index]);

    return (
      <>
        {/* Sezione foto con le definizioni sopra */}
        <Row key={photoIndex} style={{ marginBottom: "32px", alignItems: "center" }} gutter={16}>
          {/* Sezione foto */}
          <Col span={13} style={reverse ? { order: 1 } : { order: 0 }}>
            <Image
              src={photo?.url || ""}
              alt={`Foto ${photoIndex + 1}`}
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </Col>

          {/* Sezione definizioni sopra */}
          <Col span={11} style={reverse ? { order: 0 } : { order: 1 }}>
            {topDefinitions.map((def, idx) => {
              const globalIndex = topIndices[idx];
              return (
                <TestUI
                  key={globalIndex}
                  testDefinition={def}
                  testSelection={posturalExamination.testSelections?.[globalIndex]}
                  setTestSelection={setTestSelection}
                />
              );
            })}
          </Col>
        </Row>

        {/* Seconda riga di definizioni sotto */}
        <Row style={{ marginBottom: "32px" }} gutter={16}>
          <Col span={24}>
            {bottomDefinitions.map((def, idx) => {
              const globalIndex = bottomIndices[idx];
              return (
                <TestUI
                  key={globalIndex}
                  testDefinition={def}
                  testSelection={posturalExamination.testSelections?.[globalIndex]}
                  setTestSelection={setTestSelection}
                />
              );
            })}
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {page === 1 && (
        <>
           {window.innerWidth <= 768 ? (
<>
           {renderPhotoWithDefinitions(0, [], [0, 3, 1, 1])}
           </>
            ) : (
              <>

              {renderPhotoWithDefinitions(0, [0, 3], [1, 2])}
              </>
            )}
        </>
      )}
    </>
  );
};

export const ComparePodo = (props: any) => <ComparePhotosComponent {...props} reverse={true} />;
export const ComparePodo2 = (props: any) => <ComparePhotosComponent {...props} reverse={false} />;
